export default __webpack_public_path__ + "static/climbing_nate-829acd93b501d203b2d4e21ec36f0158.jpg";